import { render, staticRenderFns } from "./RIB.vue?vue&type=template&id=13271ace&"
import script from "./RIB.vue?vue&type=script&lang=js&"
export * from "./RIB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports